import { render, staticRenderFns } from "./common-access-actions.vue?vue&type=template&id=779db5b4"
import script from "./common-access-actions.vue?vue&type=script&lang=js"
export * from "./common-access-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports